import { useState, useEffect } from 'react';
import { analyzeRecipeInput, testApiConnection } from '../services/chatGptService';
import { generateFoodImage } from '../services/leonardoService';
import axios from 'axios';
import { sessionManager } from '../services/sessionManager';

export const useRecipe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [recipe, setRecipe] = useState(null);
  const [step, setStep] = useState('input');
  const [isApiAvailable, setIsApiAvailable] = useState(true);

  // Проверяем доступность API при монтировании
   

  // Проверяем сохранённый результат при загрузке
  useEffect(() => {
    const checkSavedResult = () => {
      if (sessionManager.hasSavedResult()) {
        const savedRecipe = sessionManager.getSavedResult();
        setRecipe(savedRecipe);
        setStep('result');
      }
    };

    checkSavedResult();
  }, []);

  const processUserInput = async (input) => {
    if (!input.trim()) return;
    if (!isApiAvailable) {
      setError('API service is not available');
      setStep('error');
      return;
    }

    try {
      // Проверяем, может ли пользователь сделать запрос
      const canRequest = await sessionManager.canMakeRequest();
      
      if (!canRequest) {
        throw new Error('Вы уже сгенерировали рецепт. Пожалуйста, используйте другое устройство или сеть для нового запроса.');
      }

      setIsLoading(true);
      setStep('loading');
      setError(null);

      // Получаем данные рецепта
      const recipeData = await analyzeRecipeInput(input);
      
      // Сохраняем сессию и результат
      await sessionManager.saveSession(recipeData);
      
      // Устанавливаем рецепт без ожидания загрузки изображения
      setRecipe(recipeData);
      setStep('result');
        console.log('🚀 recipeData', recipeData);
      // Запускаем генерацию изображения после основного процесса
      // Это позволит интерфейсу быстрее реагировать
      generateFoodImage(recipeData[0])
        .then(imageUrl => {
          // Обновляем рецепт с изображением
          const updatedRecipeData = { ...recipeData, imageUrl: imageUrl };
          setRecipe(updatedRecipeData);
 
          // Обновляем сохраненный результат
          sessionManager.saveSession(updatedRecipeData);
          
          console.log('✅ Изображение успешно сгенерировано');
                    setIsLoading(false);

        })
        .catch(imgError => {
          console.error('❌ Ошибка при генерации изображения:', imgError);
          // Продолжаем без изображения
        });

    } catch (error) {
      console.error('Ошибка при обработке запроса:', error);
      setError(error.message);
      setStep('error');
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setStep('input');
    setRecipe(null);
    setError(null);
  };

  const setMockRecipe = (mockData) => {
    setIsLoading(true);
    setStep('loading');
    
    setTimeout(() => {
      setRecipe(mockData);
      setStep('result');
      setIsLoading(false);
    }, 1000);
  };

  return {
    isLoading,
    error,
    recipe,
    step,
    isApiAvailable,
    processUserInput,
    reset,
    setMockRecipe,
  };
}; 